import React from 'react';

import { Badge } from '@/ux-common/components/badge/badge';
import { cn } from '@/ux-common/lib/utils';

import { ActionComponentProps } from './types';

export const ActionComponentBadge: React.FC<ActionComponentProps> = ({ state }) => {
  const variant = state?.actionComponentConfig?.badgeComponentConfig?.variant;

  return (
    <Badge className={cn('badge hover:cursor-default w-full', `badge-${variant}`)}>
      {state?.actionComponentConfig?.badgeComponentConfig?.label ?? ''}
    </Badge>
  );
};
